var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"justify-content-center"},[_c('lottie-player',{staticStyle:{"width":"300px","height":"300px"},attrs:{"src":"https://assets8.lottiefiles.com/packages/lf20_jdzh9agx.json","background":"transparent","speed":"1.10","autoplay":"","title":_vm.i18nNoRecordsFound}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }